import * as React from 'react';

import {colors} from 'shells/colors/colors';

import type {PeepRelatedLeadStat as PeepRelatedLeadStatFragment} from 'nutshell-graphql-types';

import styles from './peep-related-lead-stat.module.css';

type Props = {
    stat: PeepRelatedLeadStatFragment;
};

export class PeepRelatedLeadStat extends React.Component<Props> {
    render() {
        const stat = this.props.stat;
        const formattedValue = stat.value.formattedValue;

        return (
            <div className={styles['peep-related-lead-stat']}>
                <div style={{color: getValueColor(stat.status)}} className={styles.value}>
                    <span>
                        {formattedValue.prefix}
                        {formattedValue.formatted}
                        {formattedValue.suffix}
                    </span>
                </div>
                <div className={styles.count}>{stat.count}</div>
                <div className={styles.status}>{stat.status.toLowerCase()}</div>
            </div>
        );
    }
}

function getValueColor(status: PeepRelatedLeadStatFragment['status']): string {
    switch (status) {
        case 'WON':
            return colors.green;
        default:
            return colors.grey;
    }
}
